export enum OENEntryType {
  SPOT,
  ALGO,
  NDF,
  BENCHMARK,
  GAMMA,
  NDF_ALGO,
}
